import { render, staticRenderFns } from "./NewsInnerBanner3.vue?vue&type=template&id=0c8b9d0e&"
import script from "./NewsInnerBanner3.vue?vue&type=script&lang=js&"
export * from "./NewsInnerBanner3.vue?vue&type=script&lang=js&"
import style0 from "./NewsInnerBanner3.vue?vue&type=style&index=0&id=0c8b9d0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports